import { MouseEvent, useCallback, useState } from "react";

import DragState from "../types/DragState";

const INITIAL_DRAG_STATE: DragState = {
  isDown: false,
  scrollLeft: 0,
  scrollTop: 0,
  startX: 0,
  startY: 0,
};

const DRAG_SPEED = 1.5;

const useDragging = (container: HTMLElement | null) => {
  const [dragState, setDragState] = useState<DragState>(INITIAL_DRAG_STATE);

  const handleMouseDown = useCallback(
    (e: MouseEvent) => {
      e.preventDefault();
      if (!container) {
        return;
      }
      setDragState({
        isDown: true,
        scrollLeft: container.scrollLeft,
        scrollTop: container.scrollTop,
        startX: e.pageX - container.offsetLeft,
        startY: e.pageY - container.offsetTop,
      });
    },
    [container]
  );

  const handleMouseUp = useCallback(() => {
    setDragState((state) => ({ ...state, isDown: false }));
  }, []);
  const handleMouseLeave = useCallback(() => {
    setDragState((state) => ({ ...state, isDown: false }));
  }, []);

  const handleMouseMove = useCallback(
    (e: MouseEvent) => {
      e.preventDefault();
      if (container && dragState.isDown) {
        e.preventDefault();
        const x = e.pageX - container.offsetLeft;
        const y = e.pageY - container.offsetTop;
        const offsetX = (x - dragState.startX) * DRAG_SPEED;
        const offsetY = (y - dragState.startY) * DRAG_SPEED;
        container.scrollLeft = dragState.scrollLeft - offsetX;
        container.scrollTop = dragState.scrollTop - offsetY;
      }
    },
    [container, dragState]
  );

  return [dragState, handleMouseDown, handleMouseUp, handleMouseMove, handleMouseLeave] as const;
};

export default useDragging;
